import { ReactComponent as AccountIcon } from 'common/assets/icons/domain-specific/Trading/sidebar/accounts.svg';
import { ReactComponent as AnalyticsIcon } from 'common/assets/icons/domain-specific/Trading/sidebar/analytics.svg';
import { ReactComponent as DepositIcon } from 'common/assets/icons/domain-specific/Trading/sidebar/deposit.svg';
import { ReactComponent as BonusIcon } from 'common/assets/icons/domain-specific/Trading/sidebar/bonus.svg';
import { ReactComponent as FaqIcon } from 'common/assets/icons/domain-specific/Trading/sidebar/faq.svg';
import { ReactComponent as TradingIcon } from 'common/assets/icons/domain-specific/Trading/sidebar/trading.svg';
import { ReactComponent as Wrench } from 'common/assets/icons/domain-specific/Trading/sidebar/wrench.svg';
import routes from 'common/constants/routing.constants';

export const sectionOne = [
  { ...routes.trading, Icon: TradingIcon, dataTestID: 'trading-trading' },
  { ...routes.profile, Icon: Wrench, dataTestID: 'trading-wrench' },
  { ...routes.accounts, Icon: AccountIcon, dataTestID: 'trading-account' },
  { ...routes.operations, Icon: DepositIcon, dataTestID: 'trading-deposit' },
];
export const sectionTwo = [
  // { ...routes.bonus, Icon: BonusIcon, dataTestID: 'trading-bonus' },
  { ...routes.analytics, Icon: AnalyticsIcon, dataTestID: 'trading-analytics' },
];
export const sectionThree = [
  { ...routes.faq, Icon: FaqIcon, dataTestID: 'trading-faq' },
];
